import html2canvas from "html2canvas";
import PptxGenJS from 'pptxgenjs';
import sg3Logo from '../images/sg3IntegrationKey.png';
import { isNullUndefinedOrEmpty } from "../common/Helpers";

export const exportToImage = async (element, imageFileName) => {

  const diagonalLine = element.querySelectorAll('.diagonalLine');
  diagonalLine.forEach(element => {
    element.classList.add('blueTopBottom-screenshot');
    element.classList.add('border-start');
    element.classList.add('border-3');
    element.classList.add('ms-2');
  });

  html2canvas(element).then((canvas) => {
    const image = canvas.toDataURL("image/png", 1.0);
    downloadImage(image, imageFileName);

    diagonalLine.forEach(element => {
      element.classList.remove('blueTopBottom-screenshot');
      element.classList.remove('border-start');
      element.classList.remove('border-3');
      element.classList.remove('ms-2');
    });
  });
};



export const exportToPPT = async (pivotItem, pivotLinkClass, objItem, clientLogo) => {
  let response = false;

  try {
    const arrTblHeader = [
      [
          { text: objItem.contractName, options: { fill: 'FFFFFF', color: '707B7C', valign: 'middle', align: 'left', fontFace: 'Arial', fontSize: 10 } },                
          { text: objItem.contractCode, options: { fill: 'FFFFFF', color: '707B7C', valign: 'middle', align: 'left', fontFace: 'Arial', fontSize: 10 } },
          { text: objItem.eeccName, options: { fill: 'FFFFFF', color: '707B7C', valign: 'middle', align: 'right', fontFace: 'Arial', fontSize: 10 } },
    
      ],
      [
          { text: objItem.areaName, options: { fill: 'FFFFFF', color: '707B7C', valign: 'middle', align: 'left', fontFace: 'Arial', fontSize: 10 } },
          { text: objItem.adnName, options: { fill: 'FFFFFF', color: '707B7C', valign: 'middle', align: 'left', fontFace: 'Arial', fontSize: 10 } },
          { text: objItem.period, options: { fill: 'FFFFFF', color: '707B7C', valign: 'middle', align: 'right', fontFace: 'Arial', fontSize: 10 } },
      ],
    ];

    const pptx = new PptxGenJS();
    pptx.title = objItem.sufixTitle;
    pptx.subject = 'Tripontis';
    pptx.author = 'SG3';
    pptx.company = 'Tripontis';
    pptx.layout = 'LAYOUT_WIDE';

    if (pivotItem) {
      const pivotItemsToClick = document.querySelectorAll(pivotLinkClass);
      const addDiapoToPPTX = (imagenDataURL) => {
        const slide = pptx.addSlide();
        const arrBorder = [{ color: 'EAEAEA', pt: 0 }, { color: 'EAEAEA', pt: 0 }, { color: 'EAEAEA', pt: 0 }];

        slide.addTable(arrTblHeader, { x: 0.5, y: 0.5, w:'92%', h: '7%', border: arrBorder})
        slide.addImage({ path:imagenDataURL, x:0.75, y:2, w:'90%', h: '50%' });
      };

      const homeSlide = pptx.addSlide();
      homeSlide.addText(objItem.sufixTitle, { x: 0.01, y: 3.2, fill: 'FFFFFF', color: '17375E', valign: 'middle', align: 'right', fontFace: 'Arial Narrow', fontSize: 10 });
      homeSlide.addText(objItem.contractCode, { x: 0, y: 3.5, fill: 'FFFFFF', color: '17375E', valign: 'middle', align: 'right', fontFace: 'Arial Narrow', fontSize: 24 });        
      homeSlide.addShape(pptx.ShapeType.line, { x: 4.95, y: 3.9, w: 5, h: 0, line: '17375E', line_size: 1 });
      homeSlide.addText(`${objItem.periodText} ${objItem.period}`, { x: 0.01, y: 4, fill: 'FFFFFF', color: '17375E', valign: 'middle', align: 'right', fontFace: 'Arial Narrow', fontSize: 14 }); 
    
      if (!isNullUndefinedOrEmpty(clientLogo))
      {
        homeSlide.addImage({ path: clientLogo, x: 0.7, y: 3.5, h: 0.5, w: 3 });   
      }
      homeSlide.addImage({ path: sg3Logo, x: 3.9, y: 3.2, h: 1, w: 1 });

      for (let i = 0; i < pivotItemsToClick.length; i++) {
        pivotItemsToClick[i].click();

        await new Promise((resolve) => setTimeout(resolve, 1250));
        
        const canvas = await html2canvas(pivotItem);
        const imagenDataURL = canvas.toDataURL("image/png", 1.0);
        addDiapoToPPTX(imagenDataURL);
      }
      
      pivotItemsToClick[0].click();

      pptx.writeFile(`${objItem.prefixTitle} - ${objItem.sufixTitle} (${objItem.contractCode}).pptx`, (error) => {});

      response = true;
    }


  } catch (error) {
    response = false;
  }

  return response;  
};

const downloadImage = (blob, fileName) => {
  const fakeLink = window.document.createElement("a");
  fakeLink.style = "display:none;";
  fakeLink.download = fileName;

  fakeLink.href = blob;

  document.body.appendChild(fakeLink);
  fakeLink.click();
  document.body.removeChild(fakeLink);

  fakeLink.remove();
};